var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhone(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.746 22.667c-.22-.001-.438-.024-.652-.07a22.34 22.34 0 01-10.832-5.525c-2.937-2.799-4.975-6.363-5.865-10.26-.105-.486-.08-.99.075-1.463.154-.473.43-.9.804-1.24l2.607-2.43a1.343 1.343 0 011.004-.341c.19.019.372.078.535.173.164.095.304.223.41.376l3.259 4.666a.987.987 0 01-.072 1.2L8.383 9.647a11.97 11.97 0 002.718 3.719 12.583 12.583 0 003.956 2.582l2.027-1.56a1.096 1.096 0 011.212-.076l4.92 3.082c.17.098.313.232.421.39a1.239 1.239 0 01.149 1.091c-.062.181-.165.346-.302.483l-2.542 2.437a3.098 3.098 0 01-1.008.648c-.377.15-.781.226-1.188.224z",
    stroke: "currentColor",
    strokeWidth: 1.5
  })));
}
export default SvgPhone;